exports.APIS = {
  Auth: "/funrep/funrep-auth/funrep-login",
  PasswordReset: "/funrep/funrep-auth/password-reset",
  PinReset: "/funrep/funrep-auth/pin-reset",
  UpdateProfile: "/admin/user",

  User: "/admin/user",

  Commons: {
    AllReceviables: "/funrep/common/manage-points/receviables",
    AllTransferable: "/funrep/common/manage-points/transferable",
    TransferPoint: "/funrep/common/manage-points/pointtransfer",
    StatusPoint: "/funrep/common/manage-points/status",
    AgentPanelText: "/common/masters/agent-panel-text",
    FunTagregtResult: "/common/auth/fun-target-result",
    RouletteResult: "/common/auth/roulette-result",
  },
};
